export default __webpack_public_path__ + "static/media/filters-ss1.76291b6a.png";